import _ from "lodash";
import LZString from "lz-string";
import * as z from "../../../framework";

export function buildErrorCodes() {
    var deferred = $.Deferred();

    if (localStorage.errorCode) {
        _.assign(z.errorCode, $.parseJSON(LZString.decompressFromUTF16(localStorage.errorCode)));
        deferred.resolve();
    } else {
        z.ajax({
            type: "GET",
            url: "ErrorCode"
        }).done(function (data) {
            $.each(data.d.results, function (index, element) {
                z.errorCode[element.Name] = element.ErrorCodeNumber;
            });

            localStorage.setItem("errorCode", LZString.compressToUTF16(JSON.stringify(z.errorCode)));

            deferred.resolve();
        }).fail(function (e) {
            deferred.reject(e);
        });
    }

    return deferred.promise();
}
